import React, { useState } from 'react';
import { Mail, Check } from 'lucide-react';

const EMAIL = 'contact@smart-resell.com';

const ContactPage: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-100 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo192.png" alt="SmartResell" className="w-8 h-8 rounded-xl" />
            <span className="font-bold text-lg" style={{ color: '#0d9488' }}>SmartResell</span>
          </div>
          <a href="/" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">← Retour</a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Nous contacter</h1>
        <p className="text-gray-500 mb-10">Une question, un problème ou une suggestion ?</p>

        {/* Contact card */}
        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 mb-6 flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#ccfbf1' }}>
            <Mail size={24} style={{ color: '#0d9488' }} />
          </div>
          <p className="text-gray-700 mb-3">Pour toute demande, écris-nous directement à :</p>
          <button
            onClick={copyEmail}
            className="font-mono font-bold text-xl hover:underline flex items-center gap-2 transition-colors"
            style={{ color: copied ? '#059669' : '#0d9488' }}
          >
            {copied ? <Check size={18} /> : null}
            {copied ? 'Copié !' : EMAIL}
          </button>
          <p className="text-sm text-gray-400 mt-3">Clique pour copier — Nous répondons généralement sous 24h.</p>
        </div>

        {/* Support technique block */}
        <div className="bg-violet-50 border border-violet-100 rounded-2xl p-8">
          <h2 className="text-lg font-bold text-violet-800 mb-3">Support technique</h2>
          <p className="text-gray-700 leading-relaxed">
            Tu rencontres un bug ou un problème avec le CRM ? Inclus dans ton message : ton adresse email de compte, une description du problème et si possible une capture d'écran.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-sm text-gray-400">
          SmartResell — <button onClick={copyEmail} className="text-teal-600 hover:underline">{EMAIL}</button>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
